/* Component Dependencies */
var textLinkTemplate = require('templates/textLink.hbs');
var AriesComponent = require('libs/aries-component');

AriesComponent.create({
 
  type: 'textLink',

  template: {
    'textLink': textLinkTemplate
  }
  
});
